import Vue from "vue";

import { i18n } from '@kano/i18n';

import OtherCryptocurrenciesList from "./components/OtherCryptocurrencies/OtherCryptocurrenciesList.vue";
import { initialDataParser } from "@/utilities/initialData";

let appInstance: Vue|null = null;
export const mountOtherCryptocurrenciesListApp = () => {
  if (appInstance !== null) {
    appInstance.$destroy();
  }

  const { props } = initialDataParser("other-cryptocurrencies", ["props"]);
  appInstance = new Vue({
    i18n,
    render: h => h(OtherCryptocurrenciesList, {
      props,
    }),
  }).$mount('#other-cryptocurrencies-list');
}

mountOtherCryptocurrenciesListApp();

